quoteModule.factory("DealInfo", function() {
    var DealInfo = function(){
        this.termMonths = 0;
        this.financeRate = 0;
        this.amountFinanced = 0;
        this.saleType = "RetailFinanced";
        this.sellingPrice = 0;
        this.MSRP = 0;
        this.daysToFirst = 0;
        this.isLeaseMoneyFactor = false;
        this.stockNumber = "";
        this.dmsDealNumber = "";
        this.firstPaymentDate = "";
        this.salesPersonId = "";
        this.customerNumber= "";
        this.etch="";
    }

    //validation of deal data for saving a quote.. not much here because we really don't
    // require deal data to save a quote
    DealInfo.prototype.dataReadyToSaveQuote = function() {
        var dataReady = true;
        dataReady = this.termMonths >= 0 && this.financeRate >= 0 && this.amountFinanced >= 0;

        return dataReady;
    }

    //validation of deal data for saving a quote.. not much here because we really don't
    // require deal data to save a quote
    DealInfo.prototype.dealInfoComplete = function() {
        var dataReady = true;
        dataReady = parseInt(this.termMonths) > 0 && parseFloat(this.financeRate) >= 0 && (parseFloat(this.sellingPrice) > 0 || parseFloat(this.amountFinanced) > 0);

        return dataReady;
    }

    DealInfo.prototype.consumeFromRateQuoteRetrieve = function(dealRateInfo) {
        if (dealRateInfo) {
            this.termMonths = dealRateInfo.FinancedTermMonths;
            this.financeRate = dealRateInfo.MoneyFactor > 0 ? dealRateInfo.MoneyFactor : dealRateInfo.FinancedAPR;
            this.amountFinanced = dealRateInfo.AmountFinanced;
            this.saleType = dealRateInfo.VehicleSaleType;
            this.sellingPrice = dealRateInfo.PurchasePrice;
            this.MSRP = dealRateInfo.MSRP;
            this.daysToFirst = dealRateInfo.DaysToFirstPayment;
            this.isLeaseMoneyFactor = dealRateInfo.MoneyFactor > 0;
            this.stockNumber = dealRateInfo.StockNumber;
            this.dmsDealNumber = dealRateInfo.DMSDealNumber;
            this.firstPaymentDate = dealRateInfo.FirstPaymentDate;
            this.etch = dealRateInfo.EtchNumber;
        }
    }
    DealInfo.prototype.consumeFromMenuIntegration = function(integrationFinancialData){
        if (integrationFinancialData){
            this.termMonths = integrationFinancialData.financingMonths ? parseInt(integrationFinancialData.financingMonths) : 0;
            this.financeRate = integrationFinancialData.financingAPR ? parseFloat(integrationFinancialData.financingAPR) : 0;
            this.amountFinanced = integrationFinancialData.amountFinanced ? parseFloat(integrationFinancialData.amountFinanced) : 0;
            this.saleType = integrationFinancialData.saleType ? integrationFinancialData.saleType : "RetailFinanced";
            if (integrationFinancialData.sellingPrice)
                this.sellingPrice = parseFloat(integrationFinancialData.sellingPrice);
            else if (appPrefillData.providerSpecific && appPrefillData.providerSpecific['sellingPrice'])
                this.sellingPrice = parseFloat(appPrefillData.providerSpecific['sellingPrice']);
            else
                this.sellingPrice = 0;
            this.MSRP = integrationFinancialData.vehicleMSRP ? parseFloat(integrationFinancialData.vehicleMSRP) : 0;
    }
    }
    return DealInfo;
});

